/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "../../../axios-defaults";
import { authRoles } from "../../../navigation/route-config";
import { LOG_IN } from "../../../store/actions";
import { useQuery } from "../Auth/ResetPassword/ResetPassword";
import AdminContent from "./AdminTabs/AdminContent/AdminContent";
import BusinessUnit from "./AdminTabs/BusinessUnit/BusinessUnit";
import DefaultTemplates from "./AdminTabs/DefaultTemplates/DefaultTemplates";
import "./style.css";

import logger from "main/shared/logger";
const SuperAdmin = () => {
  const [key, setKey] = useState("manageBusinessUnit");
  let navigate = useNavigate();
  let query = useQuery();
  let location = useLocation();
  const dispatch = useDispatch();
  const role = useSelector((state) => state.user.data.role);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    if (role === authRoles.ultraAdmin) {
      const oldToken = localStorage.getItem("x-auth-token");
      const oldRefreshToken = localStorage.getItem("x-refresh-token");
      const userString = localStorage.getItem("oldUser");

      // Only process if oldToken and oldUser exist
      if (oldToken && userString) {
        delete axios.defaults.headers.common["X-Custom-Information"];
        axios.defaults.headers.common["Authorization"] = "Bearer " + oldToken;

        // Restore old tokens
        localStorage.removeItem("x-auth-token");
        localStorage.setItem("access_token", oldToken);

        if (oldRefreshToken) {
          localStorage.removeItem("x-refresh-token");
          localStorage.setItem("refresh_token", oldRefreshToken);
        }

        localStorage.removeItem("oldUser");

        try {
          const user = JSON.parse(atob(userString));
          dispatch({
            type: LOG_IN,
            payload: user,
          });
        } catch (error) {
          logger.error("Error parsing user data:", error);
        }
      }
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    setKey(query.get("tab") || "manageBusinessUnit");
  }, [query]);

  return (
    <div className="main">
      <Tabs
        className="setting-tab-btns"
        defaultActiveKey="manageBusinessUnit"
        activeKey={key}
        onSelect={(k) => {
          navigate(`${location.pathname}?tab=${k}`);
        }}
      >
        <Tab eventKey="manageBusinessUnit" title="Manage Business Unit">
          <div style={{ height: "calc(100vh - 150px)", overflowY: "auto" }}>
            {key === "manageBusinessUnit" && (
              <BusinessUnit parentLoading={isLoading} />
            )}
          </div>
        </Tab>
        <Tab eventKey="content" title="Content">
          <div style={{ height: "calc(100vh - 140px)", overflowY: "auto" }}>
            {key === "content" && <AdminContent />}
          </div>
        </Tab>
        <Tab eventKey="deafultTemplates" title="Report Templates">
          {key === "deafultTemplates" && <DefaultTemplates />}
        </Tab>
      </Tabs>
    </div>
  );
};

export default SuperAdmin;
